const SEGMENTATION_TYPE = {
  DEFAULT: 0,
  ANOMALY: 1,
};

// Mirrors the backend's SEGMENTATION_ENTITIES — decides which repository
// segmentationListUsers queried, and therefore the shape of each row.
export const SEGMENTATION_ENTITY = {
  USER: 'USER',
  ENTRY: 'ENTRY',
};

// Anomalies are created by us (no dedicated "entity" field comes back from
// segmentationList yet), so we keep our own title -> entity lookup here,
// the same way `constants/printModel.ts` keeps a frontend-owned catalog for
// print materials options. Anything not listed here falls back to USER.
const ANOMALY_ENTITY_BY_TITLE: Record<string, string> = {
  'Entradas sem BPe': SEGMENTATION_ENTITY.ENTRY,
  'Quantidade de Cartões': SEGMENTATION_ENTITY.USER,
};

export const getAnomalyEntity = (title?: string): string =>
  (title && ANOMALY_ENTITY_BY_TITLE[title]) || SEGMENTATION_ENTITY.USER;

export default SEGMENTATION_TYPE;
